import {
  Flex,
  IconWrap,
  MessagesBubbleSquareTextIcon,
  Stack,
  Tooltip
} from '@libs/ui/ds'
import { usePlanningTranslation } from '@libs/utils/translations'
import { CardFooter } from '@spa/scenes/Plannings/components'
import type { RestModel } from '@spa/scenes/Plannings/redux/models/Rest'
import type { ShiftModel } from '@spa/scenes/Plannings/redux/models/Shift'
import type { FC } from 'react'
import React from 'react'

type Props = {
  shift: ShiftModel
  rest?: RestModel
}

const ShiftNote: FC<Props> = ({ shift, rest }) => {
  const { t } = usePlanningTranslation()
  const count = [shift.note, shift.real_note, rest?.note].filter(Boolean).length

  if (!count) {
    return null
  }

  return (
    <CardFooter.ActionItem>
      <Tooltip
        id='shift-note'
        label={
          <Stack gap={2} col>
            {!!shift.note && (
              <div>{t('weekly.card.note', { note: shift.note })}</div>
            )}
            {!!shift.real_note && (
              <div>{t('weekly.card.note', { note: shift.real_note })}</div>
            )}
            {!!rest?.note && (
              <div>{t('weekly.card.note', { note: rest.note })}</div>
            )}
          </Stack>
        }
      >
        <Flex row className='flex-nowrap items-center'>
          {count > 1 && <div>{count}</div>}
          <IconWrap icon={<MessagesBubbleSquareTextIcon />} size='s' />
        </Flex>
      </Tooltip>
    </CardFooter.ActionItem>
  )
}

export default ShiftNote
